<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      @if (this.comment()) {
        <ion-button (click)="delete()">
          <div>Löschen</div>
        </ion-button>
      } @else {
        <ion-button (click)="cancel()">
          <div>Abbrechen</div>
        </ion-button>
      }
    </ion-buttons>
    <ion-title>Kommentar</ion-title>
    <ion-buttons slot="end">
      <ion-button
        (click)="save()"
        [disabled]="!this.commentForm.valid"
        [strong]="true"
        >Speichern</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form
    [formGroup]="commentForm"
    class="bg-iosbackground dark:bg-transparent pt-5"
  >
    <ion-list class="mt-5 mb-5">
      <ion-item lines="full">
        <ion-textarea
          class="textarea"
          #input
          formControlName="comment"
          placeholder="Kommentar"
        ></ion-textarea>
      </ion-item>
    </ion-list>
  </form>
</ion-content>
